import { Alert } from "@idg-web-platform/pulse";
import { InvoiceAddress } from "../../interfaces/invoiceAddress.ts";
import { useEffect, useState } from "preact/hooks";
import css from "./addressUpdateAlert.module.css";

interface AddressUpdateFragmentProps {
  newAddress: InvoiceAddress;
  updatedAt: string;
}

AddressUpdateAlert.tagName = "control-address-update-fragment";

export function AddressUpdateAlert(props: AddressUpdateFragmentProps) {
  const [showAlert, setShowAlert] = useState(true);

  const updateAddress = async () => {
    try {
      // Update the address in your backend here
      console.debug("Updating address to:", props.newAddress);
      const response = await fetch("/api/c/account/update-invoice-address", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(""),
      });

      if (!response.ok) {
        console.error("Failed to finalize address update:", response);
        // Display an error message to the user
      }
    } catch (error) {
      console.error("Failed to finalize address update:", error);
      // Display an error message to the user
    }
  };
  useEffect(() => {
    updateAddress();
  }, [props.newAddress]);

  function closeAlert() {
    setShowAlert(false);
  }

  function capitalizeFirstLetter(value: string) {
    return String(value).charAt(0).toUpperCase() + String(value).slice(1);
  }

  const alertMessage = (
    <div>
      Du hast deine Rechnungsadresse am {props.updatedAt} bei einem INTERSPORT Händler vor Ort wie
      folgt geändert.
      <br />
      <b>
        {capitalizeFirstLetter(props.newAddress.firstName) +
          " " +
          capitalizeFirstLetter(props.newAddress.lastName) +
          ", " +
          props.newAddress.streetName +
          " " +
          props.newAddress.streetNr +
          ", " +
          props.newAddress.zipCode +
          " " +
          props.newAddress.city}
      </b>
      <br />
      Wir haben sie in dein MEIN INTERSPORT Konto übernommen. Hier kannst du sie unter “Meine Daten”
      übrigens auch jeder Zeit wieder anpassen.
    </div>
  );

  return (
    <>
      {showAlert && (
        <div className={css.addressUpdateAlert}>
          <Alert
            type="info"
            headline="Neue Rechnungsadresse"
            description={alertMessage}
            showCloseButton={true}
            onClose={closeAlert}
          />
        </div>
      )}
    </>
  );
}
